module.exports = __webpack_public_path__ + "img/Parasram logo.8d668216.jpg";